import { ReactElement } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";

export enum ReportColumns {
  // required / primary key
  package_name = "package_name",

  // non aggregatable
  country = "country",
  ad_type = "ad_type",
  device_type = "device_type",

  // aggregatable
  revenue = "revenue",
  // net_revenue = "net_revenue",
  // revshare = "revshare",
  platform = "platform",
  impressions = "impressions",
  ecpm = "ecpm",
  clicks = "clicks",
  ctr = "ctr",
  networkName = "networkName",
}

export const reportColumnMetaData = {
  [ReportColumns.package_name]: {
    title: "Bundle Id",
    aggregatable: false,
    hoverText: "Apps package name or bundle ID",
  },
  [ReportColumns.country]: {
    title: "Country",
    aggregatable: false,
    hoverText: "Two letter country code",
  },
  [ReportColumns.platform]: {
    title: "Platform (OS)",
    aggregatable: true,
    hoverText: "Android or iOS",
  },
  [ReportColumns.ad_type]: {
    title: "Ad Type",
    aggregatable: false,
    hoverText:
      "The type of ad that was displayed (GRAPHIC, PLAY, VIDEO, REWARD, or MRAID)",
  },
  [ReportColumns.device_type]: {
    title: "Device Type",
    aggregatable: false,
    hoverText: "phone, tablet, or other",
  },
  [ReportColumns.networkName]: {
    title: "Ad Network",
    aggregatable: true,
    hoverText: "The ad-network this data comes from.",
  },
  [ReportColumns.revenue]: {
    title: "Revenue",
    aggregatable: true,
    hoverText: "Ad revenue earned based on the revshare associated with your current Buildbox subscription. It is possible that your actual paid revenue was different if your Buildbox subscription has changed since this revenue was paid out."
  },
  // [ReportColumns.net_revenue]: {
  //   title: "Estimated Net Revenue",
  //   aggregatable: true,
  //   hoverText: "Money earned",
  // },
  // [ReportColumns.revshare]: {
  //   title: "Rev-Share Percentage",
  //   aggregatable: true,
  //   hoverText: ""
  // },

  [ReportColumns.impressions]: {
    title: "Impressions",
    aggregatable: true,
    hoverText: "Number of impressions",
  },
  [ReportColumns.ecpm]: {
    title: "ECPM",
    aggregatable: true,
    hoverText:
      "Effective cost per thousand impressions: money earned per 1000 impressions",
  },
  [ReportColumns.clicks]: {
    title: "Clicks",
    aggregatable: true,
    hoverText: "Number of clicks",
  },
  [ReportColumns.ctr]: {
    title: "CTR",
    aggregatable: true,
    hoverText: "Number of clicks ÷ number of impressions",
  },
};

export const headerOrder = [
  ReportColumns.package_name,
  ReportColumns.country,
  ReportColumns.platform,
  ReportColumns.ad_type,
  ReportColumns.device_type,
  ReportColumns.networkName,
  ReportColumns.revenue,
  // ReportColumns.net_revenue,
  // ReportColumns.revshare,
  ReportColumns.impressions,
  ReportColumns.ecpm,
  ReportColumns.clicks,
  ReportColumns.ctr,
];

export const aggregatable = headerOrder.filter(
  (column) => reportColumnMetaData[column].aggregatable
);

export const nonAggregatable = headerOrder.filter((column) => {
  return (
    !reportColumnMetaData[column].aggregatable &&
    // exclude package_name from this list because it
    // functions as a primay key / is required
    column !== ReportColumns.package_name
  );
});

export type ReportHeader = {
  title: string;
  Header: string | ReactElement;
  accessor: ReportColumns;
};

export type HeaderProps = {
  hoverText: string;
  title: string | ReactElement;
  children?: ReactElement[] | ReactElement;
  expandIcon?: IconDefinition;
  expandHover?: string | undefined;
  setExpand?: Function | undefined;
  expanded?: boolean | undefined;
};

export type IAdboxReport = bb.model.monetization.IAdboxReport;
export type IReportItem = bb.model.monetization.IAdboxNetworkReport;

export const NET_HOVER_TEXT =
  "This net revenue amount is an estimate and should not be considered as final, guaranteed, or completely accurate. For example, this number will not reflect any changes to your rev-share percentage that may have occurred during the selected report date-range.";
